import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SeatsBadge = ({ className = "" }) => {
  const [seats, setSeats] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/build/seats`)
      .then((r) => { if (active) setSeats(r.data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!seats) return null;
  const label = seats.left > 0 ? `${seats.left} of ${seats.total} seats left` : "Waitlist open";

  return (
    <span
      data-testid="seats-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/40 px-3 py-1 text-xs font-medium text-neutral-200 ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-70" style={{ background: "#5EC8BE" }} />
        <span className="relative inline-flex h-2 w-2 rounded-full" style={{ background: "#5EC8BE" }} />
      </span>
      {label}
    </span>
  );
};

export default SeatsBadge;
